import React, { useContext, VFC } from 'react';

import classNames from 'classnames';
import { Text } from 'mintel-react-ui';

import { BlockBackgroundContext } from '/utils/contexts';

import styles from './Context.scss';

type ContextProps = {
  content?: string;
  hide?: boolean;
};

const Context: VFC<ContextProps> = ({ content, hide = false }) => {
  const { darkBg } = useContext(BlockBackgroundContext);

  return (
    <div className={styles['block-context']}>
      {content && (
        <Text.Body darkBg={darkBg}>
          <div
            className={classNames(styles['full-height'], {
              [styles.hide]: hide,
            })}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </Text.Body>
      )}
    </div>
  );
};

export default Context;
